import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import { Guid } from "guid-typescript";
import * as _ from "lodash";
import { plainToClass } from "class-transformer";
import { ITenantKVP } from "../models/shared/tenantKVP";
import { SecurityRightModel } from "../models/rights/securityRight";
import { getTenantId } from "@/store/helper";
import { SecurityUserModel } from "../models/security-users/securityUsers";
import { UserProfileModel } from "../models/account/userProfile";
import { SecurityUserRoleVerificationModel } from "../models/security-users/securityUserRoleVerification";
import { IGetUserDetailForProfile } from "../models/account/responses/getUserDetailForProfile";
let SettingsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let SettingsModule = class SettingsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.tenants = [];
            this.tenant = null;
            this.userProfile = new UserProfileModel();
            this.securityRights = [];
            this.role = null;
            this.appMenus = [];
            this.userRights = [];
            this.userTimeZone = null;
            this.timeZones = [];
            this.userDateFormat = "";
            this.dateFormats = [];
            this.userRole = null;
            this.isTeamLead = false;
            this.apiNode = "tenantuser";
        }
        async GetTenants() {
            let { data } = await service.get("securityuser/tenants");
            if (data) {
                this.SetTenants(data.tenants);
                return data.tenants;
            }
            return [];
        }
        async AssignSelectedTenant(tenant) {
            if (tenant) {
                localStorage.setItem("tenantId", tenant.id.toString());
                localStorage.setItem("tenantName", tenant.name);
            }
            else {
                // Something wrong here
                var tenantName = localStorage.getItem("tenantName");
                var tenantId = Guid.parse(localStorage.getItem("tenantId"));
                tenant = { id: tenantId, name: tenantName, isUserAssigned: true };
            }
            this.SetTenant(tenant);
        }
        async GetUserRights() {
            var url = `${getTenantId()}/security/rights`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRights(plainToClass(SecurityRightModel, data.securityRights));
                return data;
            }
        }
        async GetUserProfile() {
            var url = `${getTenantId()}/tenantuser/profile`;
            let { data } = await service.get(url);
            if (data) {
                this.SetCurrentUserProfileImageUrl(data);
                return data;
            }
        }
        async GetFeatureRights(featureId) {
            var url = `${getTenantId()}/security/${featureId}/rights`;
            let { data } = await service.get(url);
            if (data) {
                this.SetRights(plainToClass(SecurityRightModel, data.securityRights));
                return data;
            }
        }
        async IsAppUserTeamLead() {
            var url = `${getTenantId()}/security/isTeamLead`;
            let { data } = await service.get(url);
            this.SetTeamLead(data);
            return data;
        }
        /* User Portal Roles */
        async FindUserRole() {
            let { data } = await service.get("securityuser/role");
            if (data) {
                this.SetRole(data.securityUserRoleVerification);
                return data.securityUserRoleVerification;
            }
        }
        async UpdateDateFormatAndTimeZone(payLoad) {
            var url = `${getTenantId()}/${this.apiNode}/userDateFormatAndTimeZone`;
            let { data } = await service.post(url, payLoad);
            if (data) {
                this.SetCurrentUserDateFormat(data.securityUser);
                return data;
            }
        }
        SetCurrentUserDateFormat(payLoad) {
            if (payLoad.timeZone) {
                this.userTimeZone = payLoad.timeZone;
            }
            if (payLoad.dateFormat) {
                this.userDateFormat = payLoad.dateFormat;
            }
        }
        SetRole(role) {
            //console.log('Role is being set');
            this.role = role;
        }
        SetTenants(tenants) {
            this.tenants = _.orderBy(tenants, [
                (o) => {
                    return o.name.trim().toLowerCase() || "";
                },
            ], ["asc"]);
        }
        SetTenant(tenant) {
            this.tenant = tenant;
        }
        SetRights(securityRights) {
            this.securityRights = securityRights;
        }
        SetCurrentUserProfileImageUrl(data) {
            this.userProfile.profileImageUrl = data.profileImageUrl;
            this.appMenus = data.appMenus;
            this.userRights = data.userRights;
            this.timeZones = data.timeZones;
            this.userTimeZone = data.userTimeZone;
            this.userDateFormat = data.userDateFormat;
            this.dateFormats = data.dateFormats;
            this.timeZones = data.timeZones;
            this.userRole = data.role;
        }
        async SetTeamLead(isTeamLead) {
            this.isTeamLead = isTeamLead;
        }
        get GetSelectedTenant() {
            return this.tenant;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], SettingsModule.prototype, "GetTenants", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof ITenantKVP !== "undefined" && ITenantKVP) === "function" ? _b : Object]),
        __metadata("design:returntype", Promise)
    ], SettingsModule.prototype, "AssignSelectedTenant", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], SettingsModule.prototype, "GetUserRights", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], SettingsModule.prototype, "GetUserProfile", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Guid !== "undefined" && Guid) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], SettingsModule.prototype, "GetFeatureRights", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], SettingsModule.prototype, "IsAppUserTeamLead", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
    ], SettingsModule.prototype, "FindUserRole", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof SecurityUserModel !== "undefined" && SecurityUserModel) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], SettingsModule.prototype, "UpdateDateFormatAndTimeZone", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetCurrentUserDateFormat", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof SecurityUserRoleVerificationModel !== "undefined" && SecurityUserRoleVerificationModel) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetRole", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetTenants", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof ITenantKVP !== "undefined" && ITenantKVP) === "function" ? _m : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetTenant", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetRights", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof IGetUserDetailForProfile !== "undefined" && IGetUserDetailForProfile) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], SettingsModule.prototype, "SetCurrentUserProfileImageUrl", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], SettingsModule.prototype, "SetTeamLead", null);
    SettingsModule = __decorate([
        Module({ dynamic: true, store: store, name: "settings", namespaced: true })
    ], SettingsModule);
    return SettingsModule;
})();
export const SettingModule = getModule(SettingsModule);
